import { render, staticRenderFns } from "./PrintPosting.vue?vue&type=template&id=492ecadd"
import script from "./PrintPosting.vue?vue&type=script&lang=js"
export * from "./PrintPosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports